<template>
    <section>
        <div class="row">
            <div class="col-12">
                <customer-search-box @lookup="filterCustomerList($event)"></customer-search-box>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <customer-result-list ref="refCustomerResultList" :customerFilter="customerFilter"></customer-result-list>
            </div>
        </div>
    </section>
</template>

<script>
import CustomerSearchBox from '@/components/customer/SearchBox';
import CustomerResultList from '@/components/customer/ResultList';
import ModelKeywordFilter from '@/resources/models/KeywordFilter';

export default {
    components: {
        CustomerSearchBox,
        CustomerResultList
    },
    data() {
        return {
            customerFilter: ModelKeywordFilter.data()
        }
    },
    methods: {
        filterCustomerList(value) {
            this.customerFilter = value;
            this.$refs.refCustomerResultList.loadCustomerList();
        }
    }
}
</script>